module.exports = __webpack_public_path__ + "assets/user-role.a3b07711.svg";